// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import styled from 'styled-components';
import PlayIcon from '../../../../assets/images/play-icon.svg';

function gerCircleRadius(r: number) {
  return r * 2 * Math.PI
}

function renderCircleRadius({ r }: { r: number }) {
  return gerCircleRadius(r)
}

export const S = {
  Container: styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    position: relative;
  `,
  PlayIcon: styled.img.attrs({ src: PlayIcon, alt: 'play-icon' })`
    z-index: 1;
    position: absolute;
    transform: translateX(10px);
  `,
  ProgressRingCircle: styled.circle<{ r: number}>`
    transition: 0.35s stroke-dashoffset;
    // axis compensation
    transform: rotate(-90deg);
    transform-origin: 50% 50%;

    stroke-dasharray: ${renderCircleRadius} ${renderCircleRadius};

    animation-name: rotate;
    animation-duration: 5s;
    animation-timing-function: linear;
    animation-fill-mode: none;

    @keyframes rotate {
      from {
        stroke-dashoffset: ${renderCircleRadius};
      }

      to {
        stroke-dashoffset: 0;
      }
    }
  `
}
